import { resolveLookupBinding } from '../../lookup-binding.js';
function ok() { return { ok: true }; }
function fail(field, message) {
    return { ok: false, errors: [{ field, message }] };
}
const lookupTable = {
    id: 'lookup_table',
    family: 'lookup',
    label: 'Lookup table',
    description: 'Map a value via a real Lookup Table (match/return columns) or inline match/output pairs.',
    defaultConfig: { entries: [], matchMode: 'exact' },
    evaluate: (input, config, ctx) => {
        const c = config;
        const s = input === null || input === undefined ? '' : String(input);
        // tableId mode (F-032) — keyed lookup against a resolved LookupTable.
        if (c.mode === 'table') {
            const table = ctx?.lookupTables?.[c.tableId ?? ''];
            // matchValue defaults to the piped input value.
            const matchValue = c.matchValue ?? { kind: 'literal', value: s };
            const binding = {
                tableId: c.tableId ?? '', matchColumn: c.matchColumn ?? '',
                matchValue, returnColumn: c.returnColumn ?? '',
            };
            const fieldValues = {};
            for (const [k, v] of Object.entries(ctx?.allFieldValues ?? {})) {
                fieldValues[k] = v === null || v === undefined ? '' : String(v);
            }
            const result = resolveLookupBinding(binding, table, fieldValues);
            if (result !== null)
                return result;
            return c.default !== undefined ? c.default : s;
        }
        // inline mode (back-compat) — match/output pairs.
        for (const entry of c.entries ?? []) {
            switch (c.matchMode) {
                case 'exact':
                    if (s === entry.match)
                        return entry.output;
                    break;
                case 'prefix':
                    if (s.startsWith(entry.match))
                        return entry.output;
                    break;
                case 'regex':
                    try {
                        if (new RegExp(entry.match).test(s))
                            return entry.output;
                    }
                    catch { /* lenient: skip bad pattern at runtime; validate catches at save time */ }
                    break;
            }
        }
        return c.default !== undefined ? c.default : s;
    },
    validate: (config) => {
        const c = config;
        if (c.mode === 'table') {
            if (!c.tableId)
                return fail('tableId', 'a lookup table is required');
            if (!c.matchColumn)
                return fail('matchColumn', 'a match column is required');
            if (!c.returnColumn)
                return fail('returnColumn', 'a return column is required');
            return ok();
        }
        if (!Array.isArray(c.entries) || c.entries.length === 0)
            return fail('entries', 'at least one entry is required');
        if (!['exact', 'prefix', 'regex'].includes(c.matchMode ?? ''))
            return fail('matchMode', 'matchMode must be exact/prefix/regex');
        for (let i = 0; i < c.entries.length; i++) {
            const e = c.entries[i];
            if (!e.match)
                return fail(`entries.${i}.match`, `entry ${i + 1}: match is required`);
            if (typeof e.output !== 'string')
                return fail(`entries.${i}.output`, `entry ${i + 1}: output is required`);
            if (c.matchMode === 'regex') {
                try {
                    new RegExp(e.match);
                }
                catch (err) {
                    const m = err instanceof Error ? err.message : String(err);
                    return fail(`entries.${i}.match`, `entry ${i + 1}: invalid regex: ${m}`);
                }
            }
        }
        return ok();
    },
    formSchema: [
        { key: 'matchMode', label: 'Match mode', type: 'select', required: true, options: [
                { value: 'exact', label: 'Exact' },
                { value: 'prefix', label: 'Prefix' },
                { value: 'regex', label: 'Regex' },
            ] },
        { key: 'entries', label: 'Entries', type: 'lookup-table', required: true },
        { key: 'default', label: 'Default (optional, used when no match)', type: 'text' },
    ],
    sampleSeeds: ['INV-123', 'PO-456', 'unknown'],
};
export const lookupOps = [lookupTable];
//# sourceMappingURL=lookup-ops.js.map